import { useNavigate } from "react-router-dom";
import { User, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { UserAvatar } from "@/components/common/UserAvatar";
import { useAuth } from "@/context/AuthContext";
import { useAnalytics } from "@/hooks/useAnalytics";
import { useUserDetails } from "@/hooks/api/useUserDetails";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export const UserMenuButton = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const { trackUserInteraction } = useAnalytics();
  const { data: userDetails } = useUserDetails();

  const displayName = userDetails?.first_name
    ? `${userDetails.first_name} ${userDetails.last_name}`.trim()
    : user?.name || "User";
  const avatarUrl = userDetails?.avatar
    ? (userDetails.avatar.startsWith('/') || userDetails.avatar.startsWith('http')
        ? userDetails.avatar
        : `/images/avatars/${userDetails.avatar}`)
    : user?.avatarUrl || "";

  const handleLogout = () => {
    trackUserInteraction("logout", "app_header");
    logout();
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="rounded-full p-1 h-auto w-auto focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0">
          <UserAvatar
            src={avatarUrl}
            name={displayName}
            size="medium"
          />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>My Account</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => navigate("/profile")}>
          <User className="mr-2 h-4 w-4" />
          <span>Profile</span>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleLogout}>
          <LogOut className="mr-2 h-4 w-4" />
          <span>Logout</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
